import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAuth } from '@/utils/local-storage'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: { name: 'PageNotFound' }
  },
  {
    path: '/404',
    name: 'PageNotFound',
    component: () => import('@/views/PageNotFound/index')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login'),
    meta: { hideSideBar: true }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home')
  },
  {
    path: '/product',
    component: () => import('@/views/Product/index.vue'),
    children: [
      {
        path: '',
        name: 'Product',
        component: () => import('@/views/Product/page/product.vue')
      }
    ]
  },
  {
    path: '/cart',
    component: () => import('@/views/Order/index.vue'),
    children: [
      {
        path: '',
        name: 'Cart',
        component: () => import('@/views/Order/page/cart.vue')
      }
    ]
  },
  {
    path: '/order',
    component: () => import('@/views/Order/index.vue'),
    children: [
      {
        path: '',
        name: 'Order',
        component: () => import('@/views/Order/page/order.vue')
      },
      {
        path: ':id',
        name: 'OrderDetail',
        component: () => import('@/views/Order/page/order-detail.vue')
      },
      {
        path: 'created/:id',
        name: 'OrderCreated',
        component: () => import('@/views/Order/page/order-created.vue')
      },
      {
        path: 'edit/:id',
        name: 'OrderEdit',
        component: () => import('@/views/Order/page/order-created.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const auth = getAuth()
  const now = (new Date()) / 1
  if (to.name !== 'Login') {
    if (auth && auth.tokenExpire >= now) {
      next()
    } else {
      router.replace({ name: 'Login' })
    }
  } else {
    next()
  }
})

export default router
